import React, { useState } from "react";
import { Card, Form, Row, Col, Image, Button } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const TravellersPhotoGallerySection = ({ data, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleImageChange = (index, value) => {
    const updatedImages = [...data.images];
    updatedImages[index] = value;
    handleChange("images", updatedImages);
  };

  const handleFileUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleImageChange(index, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const addImage = () => {
    handleChange("images", [...data.images, ""]);
  };

  const removeImage = (index) => {
    const updatedImages = data.images.filter((_, i) => i !== index);
    handleChange("images", updatedImages);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Travellers Photo Gallery Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter section heading"
                />
              </Form.Group>
            </Col>
          </Row>

          <h6 className="mt-4 mb-3">Gallery Images</h6>
          {data.images.map((image, index) => (
            <div key={index} className="mb-3 p-3 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label mb-0">Image {index + 1}</label>
                {data.images.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeImage(index)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) =>
                  e.target.files?.[0] && handleFileUpload(index, e.target.files[0])
                }
                className="mb-2"
              />
              {isUploading && (
                <div className="text-muted small mt-1">Uploading...</div>
              )}
              {image && (
                <div className="mt-2">
                  <Image
                    src={image}
                    alt="Preview"
                    thumbnail
                    style={{ maxWidth: "200px" }}
                  />
                </div>
              )}
            </div>
          ))}
          <Button variant="outline-primary" onClick={addImage}>
            Add Image
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default TravellersPhotoGallerySection;
